import { render, staticRenderFns } from "./CobrancaInsumo.vue?vue&type=template&id=5c7645f8&"
import script from "./CobrancaInsumo.vue?vue&type=script&lang=js&"
export * from "./CobrancaInsumo.vue?vue&type=script&lang=js&"
import style0 from "./CobrancaInsumo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports